import React from "react";
import Button from "@material-ui/core/Button";
import style from "./Card.module.css";
import img from "./demo.png";

export const BlogCard = ({ title, texto, autor, _id }) => {
  let textoNew = texto.slice(0, 150);

  var s = texto;
  var temp = document.createElement("div");
  temp.innerHTML = s;
  let htmlObject = temp;

  //Lineas 9 a 12 guardan en la variable "htmlObject" el texto con estilo, no puedo hacer que renderice correctamente

  const check = () => {
    console.log(htmlObject);
  };

  return (
    <div className={style.container}>
      <img src={img} alt="" className={style.img} />

      <div className={style.textCont}>
        <h4 className={style.title}>{title}</h4>
        {temp}

        <p className={style.texto}>{textoNew}</p>
        <button onClick={check}> test </button>
      </div>
      <div className={style.bottomCont}>
        <p className={style.texto}> {autor}</p>
      </div>
    </div>
  );
};
